/* eslint-disable no-unused-vars */
import { Navigate } from 'react-router-dom';
import { RequireAuth } from 'authenticate';
import { lazy } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import MinimalLayout from 'layout/MinimalLayout';
import Loadable from 'ui-component/Loadable';

const DashboardDefault = Loadable(lazy(() => import('views/dashboard/Default')));
const UtilsProducts = Loadable(lazy(() => import('views/utilities/Products')));
const UtilsOrders = Loadable(lazy(() => import('views/utilities/Orders')));
const UtilsInvoices = Loadable(lazy(() => import('views/utilities/Invoices')));
const UtilsOffers = Loadable(lazy(() => import('views/utilities/Offers')));
const UtilsOutlets = Loadable(lazy(() => import('views/utilities/Outlets')));
const UtilsCategory = Loadable(lazy(() => import('views/utilities/Categories')));
const UtilsBrands = Loadable(lazy(() => import('views/utilities/Brands')));
const UtilsAreas = Loadable(lazy(() => import('views/utilities/Areas')));
const UtilsCutomers = Loadable(lazy(() => import('views/utilities/Customers')));
const AuthLogin = Loadable(lazy(() => import('views/pages/authentication/authentication3/Login')));
const Settings = Loadable(lazy(() => import('views/settings')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = [
    {
        element: (
            <RequireAuth>
                <MainLayout />
            </RequireAuth>
        ),
        children: [
            {
                path: '/',
                element: <Navigate to="dashboard" />
            },
            {
                path: 'dashboard',
                element: <DashboardDefault />
            },
            {
                path: 'utils',
                children: [
                    {
                        path: 'products',
                        element: <UtilsProducts />
                    }
                ]
            },
            {
                path: 'utils',
                children: [
                    {
                        path: 'orders',
                        element: <UtilsOrders />
                    }
                ]
            },
            {
                path: 'utils',
                children: [
                    {
                        path: 'invoices',
                        element: <UtilsInvoices />
                    }
                ]
            },
            {
                path: 'utils',
                children: [
                    {
                        path: 'offers',
                        element: <UtilsOffers />
                    }
                ]
            },
            {
                path: 'utils',
                children: [
                    {
                        path: 'outlets',
                        element: <UtilsOutlets />
                    }
                ]
            },
            {
                path: 'utils',
                children: [
                    {
                        path: 'category',
                        element: <UtilsCategory />
                    }
                ]
            },
            {
                path: 'utils',
                children: [
                    {
                        path: 'brands',
                        element: <UtilsBrands />
                    }
                ]
            },
            {
                path: 'utils',
                children: [
                    {
                        path: 'areas',
                        element: <UtilsAreas />
                    }
                ]
            },
            {
                path: 'utils',
                children: [
                    {
                        path: 'customers',
                        element: <UtilsCutomers />
                    }
                ]
            },
            {
                path: 'others',
                children: [
                    {
                        path: 'settings',
                        element: <Settings />
                    }
                ]
            }
        ]
    },
    {
        path: '/auth',
        element: <MinimalLayout />,
        children: [
            {
                path: 'login',
                element: <AuthLogin />
            }
        ]
    }
];

export default MainRoutes;
